import Vue from 'vue';

function isStringIncludes65279(str) {
    for (let i = 0, n = str.length; i < n; i += 1) {
        if (str.charCodeAt(i) === 65279) {
            return true;
        }
    }
    return false;
}

function putEmptyNode(el) {
    const textNode = document.createTextNode('\uFEFF'); // \u00A0
    el.appendChild(textNode);
}

function removeEmptyNode(el) {
    Object.keys(el.childNodes).forEach((i) => {
        const node = el.childNodes[i];
        if (node.nodeType === Node.TEXT_NODE) {
            if (isStringIncludes65279(node.textContent)) {
                node.textContent = '\uFEFF';
            } else {
                node.textContent = node.textContent.trim();
            }
        }
        return i;
    });
}

Vue.directive('put-empty-node', {
    inserted: putEmptyNode,
});
Vue.directive('remove-empty-node', {
    inserted: removeEmptyNode,
    componentUpdated: removeEmptyNode,
});
Vue.directive('focus', {
    // When the bound element is inserted into the DOM...
    inserted(el, binding, vnode) {
        // Focus the element
        if (vnode.componentInstance && vnode.componentInstance.focus) {
            vnode.componentInstance.focus();
        } else if (el.focus) {
            el.focus();
        }
    },
});
